var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"rev-fw-button",class:{dark: _vm.$store.state.settings.darkMode},attrs:{"to":_vm.to}},[_c('img',{attrs:{"src":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }